const publicPortalComponentLoaders = Object.freeze({
  'public-portal.booking-workspace': async () => {
    const module = await import('./public-booking-workspace-component.js');
    return module.PublicBookingWorkspaceComponent;
  },
});

export default publicPortalComponentLoaders;
